import type { MouseEvent } from "react";
import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { Column } from "../../misc/Column";

export function TimetableMobileListItem(props: {
  timetable: { name: string };
  weekdaySummaries: { label: string; summary: string }[];
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { timetable, weekdaySummaries, onClick } = props;
  const theme = useTheme();

  return (
    <ButtonBase
      component="div"
      disabled={!onClick}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
        "&.Mui-disabled": {
          color: "inherit",
        },
      }}
    >
      <Column sx={{ alignItems: "flex-start", gap: 0.5, minWidth: 0 }}>
        <Typography variant="body1" sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
          {timetable.name}
        </Typography>
        {weekdaySummaries.map(({ label, summary }) => (
          <Box key={label} sx={{ display: "grid", gridTemplateColumns: "24px minmax(0, 1fr)", gap: 1, width: "100%" }}>
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
              {label}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
              {summary}
            </Typography>
          </Box>
        ))}
      </Column>
    </ButtonBase>
  );
}
